import {
  AccountTreeOutlined,
  BusinessOutlined,
  CompareArrowsOutlined,
  FactoryOutlined,
  FolderOpenOutlined,
  HelpOutlineOutlined,
  Inventory2Outlined,
  LinkOutlined,
  ListAltOutlined,
  MergeTypeOutlined,
  PrecisionManufacturingOutlined,
  ReceiptLongOutlined,
  ScaleOutlined,
  SearchOutlined,
  SettingsOutlined,
  StorefrontOutlined,
  TravelExploreOutlined,
  UploadOutlined,
  ViewListOutlined,
} from '@mui/icons-material';
import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getRouteBrandManagement,
  getRouteCatalogMatchJobs,
  getRouteCatalogUpload,
  getRouteExternalMatches,
  getRouteHelp,
  getRouteHome,
  getRouteManufacturerManagement,
  getRouteProductList,
  getRouteProductMerge,
  getRouteSimilarProducts,
  getRouteSupplierCatalogFergusonAdhoc,
  getRouteSupplierCatalogFiles,
  getRouteSupplierCatalogUpload,
  getRouteSupplierManagement,
  getRouteUomManagement,
} from 'shared/constants/routerConst';
import { contentHeight } from 'shared/constants/styles';
import { NavList } from 'shared/ui/NavList';

export const Navbar = () => {
  const isLoading = false;

  const { t } = useTranslation();

  const navBarItemsList = useMemo(
    () => [
      {
        label: t('Search'),
        route: getRouteHome(),
        icon: SearchOutlined,
      },
      {
        label: t('Products'),
        icon: Inventory2Outlined,
        isOpenByDefault: true,
        children: [
          {
            label: t('List'),
            route: getRouteProductList(),
            icon: ViewListOutlined,
          },
          {
            label: t('Merge Products'),
            route: getRouteProductMerge(),
            icon: MergeTypeOutlined,
          },
          {
            label: t('Similar Products'),
            route: getRouteSimilarProducts(),
            icon: CompareArrowsOutlined,
          },
        ],
      },
      {
        label: t('Supplier Catalogs'),
        icon: StorefrontOutlined,
        isOpenByDefault: true,
        children: [
          {
            label: t('Upload'),
            route: getRouteSupplierCatalogUpload(),
            icon: UploadOutlined,
          },
          {
            label: t('Files'),
            route: getRouteSupplierCatalogFiles(),
            icon: FolderOpenOutlined,
          },
          {
            label: t('Ferguson Lookup'),
            route: getRouteSupplierCatalogFergusonAdhoc(),
            icon: TravelExploreOutlined,
          },
        ],
      },
      {
        label: t('Property Catalogs'),
        icon: ReceiptLongOutlined,
        children: [
          {
            label: t('Catalog Matches'),
            route: getRouteCatalogMatchJobs(),
            icon: ListAltOutlined,
          },
          {
            label: t('Upload'),
            route: getRouteCatalogUpload(),
            icon: UploadOutlined,
          },
        ],
      },
      {
        label: t('Models'),
        icon: AccountTreeOutlined,
        children: [
          {
            label: t('Brands'),
            route: getRouteBrandManagement(),
            icon: PrecisionManufacturingOutlined,
          },
          {
            label: t('Manufacturers'),
            route: getRouteManufacturerManagement(),
            icon: FactoryOutlined,
          },
          {
            label: t('Suppliers'),
            route: getRouteSupplierManagement(),
            icon: BusinessOutlined,
          },
          {
            label: t('UOM'),
            route: getRouteUomManagement(),
            icon: ScaleOutlined,
          },
        ],
      },
      {
        label: t('Settings'),
        icon: SettingsOutlined,
        children: [
          {
            label: t('External Matches'),
            route: getRouteExternalMatches(),
            icon: LinkOutlined,
          },
        ],
      },
    ],
    [t],
  );

  const bottomItemsList = useMemo(
    () => [
      {
        label: t('Help'),
        route: getRouteHelp(),
        icon: HelpOutlineOutlined,
      },
    ],
    [t],
  );

  return (
    <>
      <Box
        bgcolor="background.paper"
        height={contentHeight}
        minWidth="240px"
        maxWidth="300px"
        position="fixed"
        zIndex="drawer"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <NavList items={navBarItemsList} authIsLoading={isLoading}></NavList>

        <NavList items={bottomItemsList} authIsLoading={isLoading}></NavList>
      </Box>
      <Box height={contentHeight} minWidth="240px" maxWidth="300px" />
    </>
  );
};
